import { render, staticRenderFns } from "./TemplatesSidebarPlaceholder.vue?vue&type=template&id=4b202e8c&scoped=true"
import script from "./TemplatesSidebarPlaceholder.vue?vue&type=script&lang=js"
export * from "./TemplatesSidebarPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./TemplatesSidebarPlaceholder.vue?vue&type=style&index=0&id=4b202e8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b202e8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b202e8c')) {
      api.createRecord('4b202e8c', component.options)
    } else {
      api.reload('4b202e8c', component.options)
    }
    module.hot.accept("./TemplatesSidebarPlaceholder.vue?vue&type=template&id=4b202e8c&scoped=true", function () {
      api.rerender('4b202e8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplatesSidebarPlaceholder.vue"
export default component.exports